export default __webpack_public_path__ + "static/deep-habits-main-iPhone-11-Pro-2021-04-12-66beeb2332a6335f9108a5f0d8a6129f.png";